import { CSSProperties } from 'react';
import { Theme } from '@material-ui/core';
import { FsComponentSize } from 'globals/types';

export const getValueStyle = (valueSize: FsComponentSize): CSSProperties => ({
  fontSize: valueSize === FsComponentSize.L ? 28 : undefined,
});

export const getDescriptionStyle = (
  descriptionSize: FsComponentSize
): CSSProperties => ({
  fontSize: descriptionSize === FsComponentSize.L ? 14 : undefined,
});

export const getWrapWordsStyle = ({
  wrapWords,
  isUpSm,
}: {
  wrapWords: boolean;
  isUpSm: boolean;
}): CSSProperties => {
  return {
    display: wrapWords && isUpSm ? 'table-caption' : undefined,
  };
};

export const getInfoBoxStyle = ({
  infoBoxWidth,
  isUpSm,
}: {
  infoBoxWidth?: number;
  isUpSm: boolean;
}): CSSProperties => ({
  maxWidth: isUpSm && infoBoxWidth ? infoBoxWidth : undefined,
});

export const getContainerStyle = ({
  theme: { spacing },
  isUpSm,
}: {
  theme: Theme;
  isUpSm: boolean;
  isLastElement: boolean;
}): CSSProperties => ({
  marginRight: isUpSm ? spacing(4) : undefined,
  marginBottom: !isUpSm ? spacing(2) : undefined,
});
